export default "__VITE_ASSET__DMwFZ5mX__"